import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const CaptionContainer = styled.div`
  display: flex;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  text-transform: uppercase;
  justify-content: space-start;
  align-content: center;

  span {
    font-size: ${props => (props.theme.isXLarge ? 14 : 13)}px;
    line-height: 15px;
    margin-right: 5px;
  }

  span.main {
    color: ${props => props.theme.primaryColor};
  }
`;

const VFlex = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HFlex = styled.div`
  display: flex;
`;

const Secondary = styled.span`
  ${props => props.theme.isMobile && `
    margin-bottom: 5px;
  `};

  &&, & > a {
    color: ${props => props.theme.secondaryColor};
  }
`;

const Separator = styled(Secondary)`
  margin-right: 5px;
`;

const Mention = styled.div`
  margin-left: auto;
  ${props => props.theme.isLarge && props.items === 1 && `
    margin-right: 32px;
  `};
  padding-top: 1px;
  color: ${props => props.theme.secondaryColor};
  background-color: #e3e9ee;
  font-size: 12px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  line-height: 120%;
  text-align: center;
  text-transform: capitalize;
  border-radius: 10px;
  width: 53px;
  height: 18px;
`;

// eslint-disable-next-line complexity
export default function WireCaption({
  wire, items, mention, isBelow480,
}) {
  const caption = {};
  if (wire.category || wire.series) {
    const seriesTitle = _.get(wire, 'series.title');
    caption.text = seriesTitle || _.get(wire, 'category.name');
    caption.url = seriesTitle ? `/${wire.series.slug}` : `/categories/${wire.category.slug}`;
  }

  // TODO: this needs some future reflow to accomodate non-linewrapping
  // elements.
  return (
    <CaptionContainer>
      {!!isBelow480 && (
        <VFlex>
          {!!(wire.isSponsored) && (
            <Secondary>
              sponsored
            </Secondary>
          )}
          <HFlex>
            {!!caption.url && (
              <span className="main">
                <a href={caption.url} data-event-type="click" data-event="link_click">{caption.text}</a>
              </span>
            )}
            {mention && (
              <Mention items={items}>mention</Mention>
            )}
          </HFlex>
        </VFlex>
      )}
      {!isBelow480 && (
        <React.Fragment>
          {!!caption.url && (
            <span className="main">
              <a href={caption.url} data-event-type="click" data-event="link_click">{caption.text}</a>
            </span>
          )}
          {!!(caption.url && wire.isSponsored) && <Separator className="separator">&bull;</Separator>}
          {!!(wire.isSponsored) && (
            <Secondary>
              sponsored
            </Secondary>
          )}
          {mention && (
            <Mention items={items}>mention</Mention>
          )}
        </React.Fragment>
      )}
    </CaptionContainer>
  );
}

WireCaption.propTypes = {
  wire: PropTypes.shape({
    isSponsored: PropTypes.bool.isRequired,
    category: PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
    series: PropTypes.shape({
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
  }).isRequired,
  items: PropTypes.number.isRequired,
  isBelow480: PropTypes.bool.isRequired,
  mention: PropTypes.bool.isRequired,
};
